import {Cureus} from '../Cureus';

Cureus.AnimalSubjects = {};

//= require_tree ./AnimalSubjects